import i18nInst from 'src/i18n';
import {
  ActionData,
  ActionEnum,
  ExchangeOnlinePolicyItem,
} from 'src/pages/Policy/utils/types';

import { PolicyTypeEnum } from '@Policy/utils/constants';
import { PolicyStore } from '@Policy/store';

function getSelectedKyes(selectedList: string, allKeys: any) {
  const selectedKeys = selectedList.split('|').filter((type) => type !== '');
  const subKeys = allKeys[0].children;
  let isAddTotalKey = true;
  subKeys.forEach((singleType: any) => {
    if (
      singleType.children.every((type: any) => selectedKeys.includes(type.key))
    ) {
      selectedKeys.push(singleType.key);
    } else {
      isAddTotalKey = false;
    }
  });
  if (isAddTotalKey) {
    selectedKeys.push(allKeys[0].key);
  }
  return selectedKeys.sort();
}
function getItemList(str: string, separator = '|') {
  const list = str.split(separator).filter((item) => item.length > 0);
  const itemList = list.map((ext) => ({
    name: ext,
    value: ext,
  }));
  return itemList;
}
export const fbExceptionFileTypeListSelector = (s: PolicyStore) => {
  const fileTypes = s.config.fileTypes;
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbExceptionFileTypeList =
    template.tmFileblockings.fbExceptionFileTypeList;
  if (!fbExceptionFileTypeList) {
    return [];
  }
  const selectedKeys = getSelectedKyes(fbExceptionFileTypeList, fileTypes);
  return selectedKeys;
};

export const fbExceptionFileExtensionListSelector = (s: PolicyStore) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbExceptionFileExtensionList =
    template.tmFileblockings.fbExceptionFileExtensionList;
  if (!fbExceptionFileExtensionList) {
    return [];
  }
  const itemList = getItemList(fbExceptionFileExtensionList);
  return itemList;
};

export const fbExceptionFileNameListSelector = (s: PolicyStore) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbExceptionFileNameList =
    template.tmFileblockings.fbExceptionFileNameList;
  if (!fbExceptionFileNameList) {
    return [];
  }
  const itemList = getItemList(fbExceptionFileNameList);
  return itemList;
};

export const fbBlockFileTypeListSelector = (s: PolicyStore) => {
  const fileTypes = s.config.fileTypes;
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbBlockFileTypeList = template.tmFileblockings.fbBlockFileTypeList;
  if (!fbBlockFileTypeList) {
    return [];
  }
  const selectedKeys = getSelectedKyes(fbBlockFileTypeList, fileTypes);
  return selectedKeys;
};

export const fbBlockFileExtensionListSelector = (s: PolicyStore) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbBlockFileExtensionList =
    template.tmFileblockings.fbBlockFileExtensionList;
  if (!fbBlockFileExtensionList) {
    return [];
  }
  const itemList = getItemList(fbBlockFileExtensionList);
  return itemList;
};
export const fbBlockFileNameListSelector = (s: PolicyStore) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbBlockFileNameList = template.tmFileblockings.fbBlockFileNameList;
  if (!fbBlockFileNameList) {
    return [];
  }
  const itemList = getItemList(fbBlockFileNameList);
  return itemList;
};
export const fbIncomingRuleBlockFileTypeListSelector = (s: PolicyStore) => {
  const fileTypes = s.config.fileTypes;
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbIncomingRuleBlockFileTypeList =
    template.tmFileblockings.fbIncomingRuleBlockFileTypeList;
  if (!fbIncomingRuleBlockFileTypeList) {
    return [];
  }
  const selectedKeys = getSelectedKyes(
    fbIncomingRuleBlockFileTypeList,
    fileTypes
  );
  return selectedKeys;
};
export const fbIncomingRuleBlockFileExtensionListSelector = (
  s: PolicyStore
) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbIncomingRuleBlockFileExtensionList =
    template.tmFileblockings.fbIncomingRuleBlockFileExtensionList;
  if (!fbIncomingRuleBlockFileExtensionList) {
    return [];
  }
  const itemList = getItemList(fbIncomingRuleBlockFileExtensionList);
  return itemList;
};
export const fbIncomingRuleBlockFileNameListSelector = (s: PolicyStore) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbIncomingRuleBlockFileNameList =
    template.tmFileblockings.fbIncomingRuleBlockFileNameList;
  if (!fbIncomingRuleBlockFileNameList) {
    return [];
  }
  const itemList = getItemList(fbIncomingRuleBlockFileNameList);
  return itemList;
};
export const fbApprovedSenderEmailEntriesSelector = (s: PolicyStore) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const fbApprovedSenderEmailEntries =
    template.tmFileblockings.fbApprovedSenderEmailEntries;
  if (fbApprovedSenderEmailEntries === '') {
    return [];
  }
  const list = fbApprovedSenderEmailEntries.split(';').map((entry) => {
    return {
      value: entry,
      name: entry,
    };
  });
  return list;
};

export const fbActionDataSelector = (s: PolicyStore) => {
  const {
    setFbState,
    config: {
      featureShow: { gmailQtSettingFeatureShow },
    },
  } = s;
  const {
    tmFileblockings: { fbActionType, fbNotifyType },
  } = s.template as ExchangeOnlinePolicyItem;
  const { t } = i18nInst;
  const policyType = s.template.policyType;
  let actions: ActionEnum[] = [];
  const actionOptionsExhange = [
    ActionEnum.replaceWithTextFile,
    ActionEnum.quarantine,
    ActionEnum.delete,
    ActionEnum.pass,
  ];

  const actionOptionsEmailInline = [
    ActionEnum.replaceWithTextFile,
    ActionEnum.quarantine,
    ActionEnum.pass,
  ];
  const actionOptionsGmail = gmailQtSettingFeatureShow
    ? [
        ActionEnum.quarantine,
        ActionEnum.delete,
        ActionEnum.pass,
        ActionEnum.labelEmail,
      ]
    : [ActionEnum.delete, ActionEnum.pass, ActionEnum.labelEmail];
  const actionOptionsTeams = [
    ActionEnum.quarantine,
    ActionEnum.delete,
    ActionEnum.pass,
  ];
  const actionOptionsTeamsChat = [ActionEnum.block, ActionEnum.pass];
  const actionOptionsSalesforce = [
    ActionEnum.quarantine,
    ActionEnum.delete,
    ActionEnum.pass,
    ActionEnum.tagFileName,
  ];
  switch (policyType) {
    case PolicyTypeEnum.Exchange:
      actions = actionOptionsExhange;
      break;
    case PolicyTypeEnum.ExchangeInline:
    case PolicyTypeEnum.GmailInline:
      actions = actionOptionsEmailInline;
      break;
    case PolicyTypeEnum.Gmail:
      actions = actionOptionsGmail;
      break;
    case PolicyTypeEnum.Teams:
    case PolicyTypeEnum.OneDrive:
    case PolicyTypeEnum.SharePoint:
    case PolicyTypeEnum.Box:
    case PolicyTypeEnum.GoogleDrive:
    case PolicyTypeEnum.Dropbox:
      actions = actionOptionsTeams;
      break;
    case PolicyTypeEnum.SalesforceSandbox:
    case PolicyTypeEnum.SalesforceProduction:
      actions = actionOptionsSalesforce;
      break;
    case PolicyTypeEnum.TeamsChat:
      actions = actionOptionsTeamsChat;
      break;
    default:
      break;
  }
  const actionData: ActionData[] = [
    {
      threatType: t('policy.threatType.action'),
      handler: setFbState,
      action: fbActionType,
      actionKey: 'fbActionType',
      actions,
      notifyType: fbNotifyType,
      notifyTypeKey: 'fbNotifyType',
    },
  ];
  return actionData;
};

export const fbAdvancedOptionConfigSelector = (s: PolicyStore) => {
  const {
    config: {
      defaultValue: {
        tmFileblockings: { fbReplacementText: fbReplacementTextDefault },
      },
    },
  } = s;
  const {
    tmFileblockings: { fbReplacementFileName, fbReplacementText },
  } = s.template as ExchangeOnlinePolicyItem;
  const config = {
    replaceFileName: fbReplacementFileName,
    replaceText: fbReplacementText,
    replaceTextDefault: fbReplacementTextDefault,
  };
  return config;
};

export const fbAdvancedSettingsSelector = (s: PolicyStore) => {
  const {
    config: {
      defaultValue: {
        tmFileblockings: { fbReplacementText: fbReplacementTextDefault },
      },
    },
  } = s;
  const {
    tmFileblockings: {
      fbSecondActionEnabled,
      fbSecondActionType,
      fbFileTagContent,
      fbReplacementText,
    },
  } = s.template as ExchangeOnlinePolicyItem;
  const config = {
    secondActionEnabled: fbSecondActionEnabled,
    secondActionType: fbSecondActionType,
    replaceFileTagContent: fbFileTagContent,
    replaceText: fbReplacementText,
    replaceTextDefault: fbReplacementTextDefault,
  };
  return config;
};
